import React from "react";
import "../components/styles/KpiTable.css";
export default function KpiTable({ data, numericSummary = false }) {
  if (!Array.isArray(data) || data.length === 0) {
    return <div className="kpi-table-empty">No data available</div>;
  }

  // 🔥 Base Calculation Logic
  const totalBase = numericSummary
    ? data.reduce((acc, item) => acc + (item.base ?? 0), 0) // numeric summary → use base
    : data.reduce((acc, item) => acc + (item.value ?? 0), 0); // normal → sum of values

  return (
    <div className="kpi-table-wrapper">
      <table className="kpi-table custom-kpi">
        <thead>
          <tr>
            <th></th>
            {numericSummary ? (
              <>
                <th>Mean</th>
                <th>St. Deviation</th>
              </>
            ) : (
              <th id="valperc">Value / Percent</th>
            )}
          </tr>
        </thead>

        <tbody>
          {/* Base Row */}
          <tr className="base-row">
            <td className="row-header"><h3><i>Base (Un-weighted):</i></h3></td>
            <td colSpan={numericSummary ? 2 : 1}><b><i>{totalBase.toFixed(0)}</i></b></td>
          </tr>

          {data.map((item, idx) => (
            <React.Fragment key={idx}>
              {numericSummary ? (
                // 🔥 Numeric Summary Layout
                <tr>
                  <td>{item.name ?? "Average"}</td>
                  <td>{(item.mean ?? item.value ?? 0).toFixed(2)}</td>
                  <td>{(item.stdDev ?? item.std ?? 0).toFixed(2)}</td>
                </tr>
              ) : (
                // 🔥 Categorical KPI Layout (two-row structure)
                <>
                  <tr>
                    <td>{item.name}</td>
                    <td>{(item.percent ?? 0).toFixed(0)}%</td>
                  </tr>
                  <tr>
                    <td></td>
                    <td>{(item.value ?? 0).toFixed(0)}</td>
                  </tr>
                </>
              )}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
}